<template>
  <div>
    <div ref="directDebitComponent" >
      <div id="directDebitDetails"
                :class="[isMobile ? 'application-section mobile-height' : 'desktop-height']">
          <section id="directDebitInfo" class="container is-fluid">
          <h2>Your {{paymentOption.PaymentMethod}} membership is almost setup!</h2>
          <h3>Account details</h3>
          <div>You need to be the account holder, or be a named person on the account, in order to set up your Direct Debit instruction online.</div>
          <div>Please provide us with the account details you want us to use to set up your Direct Debit.</div>
          <div>
            If you are not the account holder, it is an account that requires more than one person to authorise payment or you don't
            want to set up a Direct Debit online, please contact the membership team on 020 75722737.
          </div>
          <div>
            Please make sure you have read our
            <a href="https://www.rcpharm.org/membership-terms-and-conditions" target="_blank">
              Membership Terms and Conditions.
            </a>
          </div>
        </section>
        <br/>
        <section id="bankDetails" class="container is-fluid">
          <div v-if="inDev">
            <p>in dev load in popup</p>
            <button v-on:click="confirm" type="button" style="cursor:pointer" class="form-button">
              Complete
            </button>
          </div>
          <div style="height:780px" v-else>
            <iframe id="iframe-asperato" :src="application.AuthorisationUrl" style="border:none" title="Direct debit"></iframe>
          </div>
          <div v-if="!isMobile">
            <button @click.stop.prevent="cancel" type="button" style="cursor:pointer" class="form-button">Go Back</button>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapState,
} from 'vuex';
import Ga from '../ga';

export default {
  name: 'DirectDebit',
  mounted() {
    window.addEventListener('message', this.messageListener);

    Ga.sendDirectDebit(this.application.Type, this.paymentOption.PaymentMethod);

    if (this.inDev) {
      window.open(this.application.AuthorisationUrl, '_blank');
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.messageListener);
  },
  data() {
    return {
      sections: {
        directDebitInfo: { tab: 0 },
        bankDetails: { tab: this.isMobile ? -1 : 0 },
      },
      submitted: false,
    };
  },
  methods: {
    HasErrorInSection() {
      return false;
    },
    confirm() {
      this.submitted = true;
      this.$emit('completed');
    },
    cancel() {
      this.$emit('returnToOption');
    },
    SetIndexes(current, next) {
      this.sections[current].tab = -1;
      this.sections[next].tab = 0;
    },
    messageListener(event) {
      console.info(event);
      switch (event.data) {
        case 'asp--cancel':
          this.cancel();
          break;
        case 'asp--exit-screen':
        case 'asp--complete':
          this.confirm();
          break;
        default: console.debug('needed to add a default');
      }
    },
  },
  computed: {
    ...mapState(['application', 'isMobile', 'paymentOption']),
    inDev() {
      return process.env.NODE_ENV === 'development';
    },
  },
};
</script>
<style lang="scss">
 #iframe-asperato {
   width:90%;
   height: 100%;
 }

  #directDebitDetails {
    &.desktop-height {
      height: 1320px;
    }

    &.mobile-height {
      height: 100%;
    }
  }
</style>
